<template>
  <div class="A1">
    <!-- 头部 -->
    <Header></Header>
    <!-- 内页大图 -->
    <Banner></Banner>
    <!-- 二级导航 -->
    <NavSecond></NavSecond>
    <!-- 面包屑 -->
    <Breadcrumb></Breadcrumb>
    <!-- 内容 -->
    <div class="container">
      <div class="wrap">
        <div class="list">
          <div class="item" v-for="(item,index) in dataList" :key="index" @click="toVideo(item)">
            <div class="pic">
              <img :src="item.picUrl" alt="">
              <img src="@/assets/images/Collection09@2x.png" alt="">
            </div>
            <div class="title text-hide">{{item.title}}</div>
          </div>
          <div style="clear: both"></div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-sizes="[6, 12, 18, 24, 30]"
            :page-size="6"
            layout="total, sizes, prev, pager, next, jumper"
            :total="config.total">
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <Footer></Footer>
    <!-- video-->
    <el-dialog v-if="dialogVisible" :title="videoTitle" :visible.sync="dialogVisible" append-to-body :before-close="toCancel">
      <video ref="video" :src="videoUrl" style="width:100%;height: 66vh;margin: 0 auto;display: block;" controls></video>
    </el-dialog>
  </div>
</template>

<script>
  import {getSingle} from "@/api"
  // import {getCollectionA2} from "@/api"
  import Header from "@/common/Header";
  import Footer from "@/common/Footer";
  import Banner from "@/common/Banner";
  import NavSecond from "@/common/NavSecond";
  import Breadcrumb from "@/common/Breadcrumb";
  import {mixin} from '@/mixin/index'

  export default {
    name: "List",
    mixins:[mixin],
    components: {
      Header,
      Footer,
      Banner,
      NavSecond,
      Breadcrumb
    },
    data(){
      return{
        // 视频
        videoTitle : '',
        videoUrl : '',
        // 弹窗
        dialogVisible:false,
        // 分页参数
        config: {
          classify: '',
          total: 0,
          page: 1,
          limit: 6
        },
        // 列表数据
        dataList:[]
      }
    },
    created(){
      // 获取数据
      this.toGetData()
    },
    methods:{
      // 显示弹窗（播放视频）
      toVideo(val){
        this.videoTitle = val.title
        this.videoUrl = val.videoUrl
        this.dialogVisible = true
        this.$nextTick(()=>{
          this.$refs.video.play()
        })
      },
      // 关闭弹窗
      toCancel(){
        this.dialogVisible = false
      },
      async toGetData(val) {
        this.dataList = []
        let params = {
          pageNum: this.config.page,
          pageSize: this.config.limit,
          orderByColumn: "create_time",
          articleClass: this.$store.getters.lang,
          articleType: "影音资料",
          articleKey:"cms",
        }
        val ? params = Object.assign({},params,val) : ''
        let {data:{rows,total}} = await getSingle(params)
        console.log(rows,total)
        rows.forEach( val => {
          this.dataList.push({
            id : val.id,
            title : val.smallTitle,
            picUrl : this.$store.getters.urlApi + val.faceUrl,
            videoUrl : this.$store.getters.urlApi + val.mxList[0].fileFullPath
          })
        })
        this.config.total = total
      },
      // 获取数据
      // toGetData() {
      //   getCollectionA2(this.config).then((res) => {
      //     this.dataList = res.data.data.list
      //     this.config.total = res.data.data.count
      //   })
      // },
      handleSizeChange(val) {
        this.config.limit = val
        this.toGetData()
      },
      handleCurrentChange(val) {
        this.config.page = val
        this.toGetData()
      }
    }
  }
</script>

<style scoped lang="less">
  body {
    background: #f6f6f6;
  }
  .el-pagination {
    text-align: center;
    padding-top: 50px;
  }
  .container{
    .wrap{
      .list{
        width: 1440px;
        margin: 0 auto 110px;
        .item{
          width: 440px;
          height: 382px;
          background: #FFFFFF;
          box-shadow: 0 5px 30px 0 rgba(0,0,0,0.15);
          margin: 0 15px 30px;
          float: left;
          padding: 20px 20px 0;
          cursor: pointer;
          .title{
            font-family: PingFangSC;
            font-weight: 500;
            font-size: 24px;
            color: #333333;
            margin-top: 24px;
          }
          .pic{
            position: relative;
            width: 100%;
            height: 285px;
            img:nth-child(1){
              width: 100%;
              height: 100%;
            }
            img:nth-child(2){
              width: 60px;
              height: 60px;
              position: absolute;
              left: 50%;
              top: 50%;
              transform: translate(-50%,-50%);
            }
          }

        }
        .item:hover{
          .title{
            color: #DA1E2D !important;
          }
        }

      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Collection/A2/A2.vue